<div class="product-list flex flex-wrap justify-content-center gap-4">
  <p-dataView #dv [value]="items" [layout]="layout">
    <ng-template pTemplate="header">
      <div class="flex justify-content-end"></div>
    </ng-template>

    <ng-template pTemplate="list" let-products>
      <div class="grid grid-nogutter">
        <div
          class="product-item product-item-list col-12 mb-3"
          *ngFor="let item of items; let first = first">
          <div class="item-wrapper sm:flex-row sm:align-items-center">
            <div class="img-wrapper sm:max-w-20rem">
              @if (item?.name.includes('(T)')) {
              <a href="{{ item?.link || '' }}">
                <img
                  class="block xl:block mx-auto w-full product-image"
                  [src]="item?.image_url || 'assets/not-available.jpeg'"
                  [alt]="item.name" />
              </a>
              } @else {
              <img
                class="block xl:block mx-auto w-full product-image"
                [src]="item?.image_url || 'assets/not-available.jpeg'"
                [alt]="item.name"
                onError="this.onerror = null; this.src='assets/not-available.jpeg';" />
              }

              <p-tag
                value="
                    {{ inventoryDescription['INSTOCK'] }}
                  "
                [severity]="getSeverity(item)"
                class="absolute"
                [style.left.rem]="0.5"
                [style.top.rem]="0.5" />
            </div>

            <div class="flex flex-column w-full justify-content-between">
              <div
                class="flex flex-column md:flex-row justify-content-between md:align-items-start flex-1 gap-4 align-self-stretch p-2">
                <div
                  class="flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                  <div class="p-3 pb-0">
                    <div class="text-lg font-medium text-900 mt-2">
                      {{ item.name?.replace('(T)', '') }}
                    </div>
                    <div
                      class="text-lg font-normal text-500 mt-2 ellipsis-block"
                      [innerHTML]="item.description"></div>
                  </div>
                </div>
              </div>

              <div
                class="w-full flex flex-column lg:flex-row gap-2 mt-auto justify-content-end pb-3 pr-3">
                <div
                  class="prize flex flex-row align-items-center justify-content-end mt-2 lg:mt-0">
                  @if(item.price){
                  <p-tag
                    styleClass="text-xl font-semibold justify-content-end px-2"
                    severity="contrast">
                    <span class="material-icons pr-2"> sell </span>
                    {{ item.price + ' €' }}
                  </p-tag>
                  } @else {
                  <p-tag
                    styleClass="text-xl font-normal justify-content-end px-4"
                    severity="contrast">
                    Precio a consultar
                  </p-tag>
                  <!-- <span class="mr-2 text-xl">Precio a consultar</span> -->
                  }
                </div>
                <!-- </div> -->
                <p-button
                  label="Ver información completa"
                  [outlined]="true"
                  styleClass="w-full"
                  (onClick)="log(item)"
                  [routerLink]="[
                    '/seguro-buceo/' +
                      item.insurance_type?.route +
                      '/' +
                      item?.route
                  ]" />

                @if (item?.name.includes('(T)')) {
                <a href="{{ item?.link || '' }}">
                  <p-button
                    [icon]="
                      item.price
                        ? 'ph ph-shopping-cart'
                        : 'ph ph-clipboard-text'
                    "
                    class="flex-auto md:flex-initial white-space-nowrap"
                    [label]="
                      item.price
                        ? 'Contrata tu seguro'
                        : 'Solicitar presupuesto'
                    "
                    [disabled]="item.inventoryStatus === 'OUTOFSTOCK'"
                    styleClass="w-full lg:w-14rem" />
                </a>
                <!-- TOREMOVE En marzo quitar enlaces temporales -->
                <!-- } @else if (item?.link?.includes('{FORM-oceanografico}')){
              <p-button
                [icon]="
                  item.price ? 'ph ph-shopping-cart' : 'ph ph-clipboard-text'
                "
                class="flex-auto md:flex-initial white-space-nowrap"
                [label]="
                  item.price ? 'Contrata tu seguro' : 'Solicitar presupuesto'
                "
                [disabled]="item.inventoryStatus === 'OUTOFSTOCK'"
                styleClass="w-full"
                (onClick)="showForm()" /> -->
                } @else {
                <p-button
                  [icon]="
                    item.price ? 'ph ph-shopping-cart' : 'ph ph-clipboard-text'
                  "
                  class="flex-auto md:flex-initial white-space-nowrap"
                  [label]="
                    item.price ? 'Contrata tu seguro' : 'Solicitar presupuesto'
                  "
                  [disabled]="item.inventoryStatus === 'OUTOFSTOCK'"
                  styleClass="w-full lg:w-14rem"
                  (onClick)="showForm(item?.link)" />

                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template let-product pTemplate="grid" let-products>
      <div class="flex flex-wrap justify-content-center">
        <div
          class="product-item product-item-grid p-2"
          *ngFor="let item of items">
          <div
            class="p-4 border-1 surface-border surface-card border-round flex flex-column">
            <div
              class="surface-50 flex justify-content-center border-round p-3">
              <div class="md:w-20rem relative">
                <img
                  class="block xl:block mx-auto w-full border-round"
                  [src]="item?.image_url || 'assets/not-available.jpeg'"
                  [alt]="item.name"
                  style="max-width: 300px"
                  onError="this.onerror = null; this.src='/assets/not-available.jpeg';" />
                <p-tag
                  value="
                    {{ inventoryDescription[item?.inventoryStatus!] }}
                  "
                  [severity]="getSeverity(item)"
                  class="absolute"
                  [style.left.rem]="0.5"
                  [style.top.rem]="0.5" />
              </div>
            </div>
            <div class="pt-4">
              <div
                class="flex flex-row justify-content-between align-items-start gap-2">
                <div>
                  <div class="text-lg font-medium text-900 mt-1">
                    {{ item.name }}
                  </div>
                  <div
                    class="text-lg font-normal text-500 mt-2"
                    [innerHTML]="item.description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dataView>
</div>
<ls-toast-atom />
